import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, TextField, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AcessarButton } from '../../Login/Styled';
import { FlexContainer } from '../../../styles/common/FlexBox';
import { useForm } from '../../../hooks/useForm';
import useEditUser from '../../../hooks/useEditUser';
import {CircularProgress} from '@mui/material';
import { formatCPF, formatDate, mapGender, validateForm} from '../../../utils/Gerais/userUtils';

const Gerais = ({ title, fields, data, onSave, loading }) => {
    const [open, setOpen] = useState(false);
    const { formData, setFormData, error, handleChange, validate } = useForm(data, (formData) => {
        return validateForm(formData, fields);
    });
    const { editUser, loading: loadingEditUser } = useEditUser();
    const onFieldChange = (e) => {
        const { name, value } = e.target;
        if (name === 'cpf') {
            const formattedCPF = formatCPF(value);
            setFormData(prev => ({ ...prev, [name]: formattedCPF }));
        } else {
            handleChange(e);
        }
    };

    const handleSave = () => {
        if (!validate()) return;

        const transformedData = { ...formData };

        fields.forEach(field => {
            if (field.name === 'cpf' && transformedData.cpf) {
                transformedData.cpf = transformedData.cpf.replace(/\D/g, '');
            }
            if (field.name === 'birthDate' && transformedData.birthDate) {
                transformedData.birthDate = formatDate(transformedData.birthDate);
            }
            if (field.name === 'gender' && transformedData.gender) {
                transformedData.gender = mapGender(transformedData.gender);
            }
        });

        onSave(transformedData);
        setOpen(false);
    };

    return (
        <>
            <AcessarButton variant="contained" onClick={() => setOpen(true)}>Editar</AcessarButton>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '22px' }}>
                    {title}
                    <IconButton onClick={() => setOpen(false)}>
                        <CloseIcon sx={{ color: 'black !important' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ padding: '2rem' }}>
                    <FlexContainer direction="column" align="center" gap="1rem">
                        {fields.map((field) => {
                            if (field.type === 'select') {
                                return (
                                    <FormControl key={field.name} variant="outlined" sx={{ width: '85%' }}>
                                        <InputLabel>{field.label}</InputLabel>
                                        <Select
                                            name={field.name}
                                            value={formData[field.name] || ''}
                                            onChange={onFieldChange}
                                            label={field.label}
                                        >
                                            {field.options.map((opt) => (
                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                );
                            }
                            if (field.type === 'date') {
                                return (
                                    <TextField
                                        key={field.name}
                                        label={field.label}
                                        name={field.name}
                                        type="date"
                                        variant="outlined"
                                        value={formData[field.name] || ''}
                                        onChange={onFieldChange}
                                        sx={{ width: '85%' }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                );
                            }
                            return (
                                <TextField
                                    key={field.name}
                                    label={field.label}
                                    name={field.name}
                                    variant="outlined"
                                    value={formData[field.name] || ''}
                                    onChange={onFieldChange}
                                    sx={{ width: '85%' }}
                                />
                            );
                        })}
                        {error && (
                            <Typography color="error" sx={{ mt: 1 }}>
                                {error}
                            </Typography>
                        )}
                        <Button
                            variant="contained"
                            sx={{
                                width: '50%', backgroundColor: 'green', color: '#fff', fontWeight: 'bold', mt: '1rem',
                                '&:hover': { backgroundColor: '#006400' }
                            }}
                            onClick={handleSave}
                        >
                            {loading ? (
                                    <CircularProgress size={24} sx={{ color: '#fff' }} />
                                ) : (
                                    'Salvar'
                            )}
                        </Button>
                    </FlexContainer>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Gerais;